export default __webpack_public_path__ + "static/media/icon_point.7dd177db.svg";